import {
    FC,
    ReactElement,
    useEffect,
    useState,
} from 'react';

import { useSearchParams } from 'react-router-dom';

import { Page, Wrapper } from '../../../components';
import { ConnectedPageHelmet, ConnectedResetPasswordForm } from '../../../connectors';
import { NotFound } from '../../../containers';
import { emailAddressParameter, tokenParameter } from '../../../entities/ResetPassword/ResetPassword';
import { AppRoute } from '../../../entities/Routing/Routing';

import './ResetPasswordPage.scss';

interface ResetPasswordPageProps {
    className?: string;
}

export const ResetPasswordPage: FC<ResetPasswordPageProps> = ({
    className = '',
}): ReactElement => {
    const [searchParams] = useSearchParams();
    const [token, setToken] = useState<string>();
    const [emailAddress, setEmailAddress] = useState<string>('');

    useEffect((): void => {
        if (!searchParams) {
            return;
        }

        const tokenQueryParam = searchParams.get(tokenParameter);

        if (tokenQueryParam) {
            setToken(tokenQueryParam);
        }

        const emailAddressQueryParam = searchParams.get(emailAddressParameter);

        if (emailAddressQueryParam) {
            setEmailAddress(emailAddressQueryParam);
        }
    }, []);

    if (!token) {
        return (
            <Page>
                <NotFound />
            </Page>
        );
    }

    return (
        <Page className={`reset-password-page ${className}`}>
            <ConnectedPageHelmet appRoute={AppRoute.resetPassword} />

            <Wrapper className="reset-password-page__wrapper">
                <ConnectedResetPasswordForm
                    token={token}
                    emailAddress={emailAddress}
                    className="reset-password-page__password-form"
                />
            </Wrapper>
        </Page>
    );
};
